export default __webpack_public_path__ + "static/media/redM.455b1842.svg";